import { render, staticRenderFns } from "./LinkToPage.vue?vue&type=template&id=8c39bb4c&"
import script from "./LinkToPage.vue?vue&type=script&lang=js&"
export * from "./LinkToPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageMainLinkToPageInner: require('/usr/src/motec/components/page/main/LinkToPageInner.vue').default})
